var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: 58,
    height: 126,
    viewBox: "0 0 58.6 126",
    style: {
      enableBackground: "new 0 0 58.6 126"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_2_);}\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -10.8765,
    y1: 108.9976,
    x2: 69.6434,
    y2: 26.5586,
    gradientTransform: "matrix(1 0 0 -1 0 128)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0130144,
    style: {
      stopColor: "#FEDD00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2166,
    style: {
      stopColor: "#FEC809"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6362,
    style: {
      stopColor: "#FF9022"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5C39"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M58.5,22.7L57,10.5C56.2,4.5,51.3,0,45.5,0H29.5h-0.3H13.1C7.4,0,2.4,4.5,1.6,10.5L0.1,22.7 c-0.5,7.2,0.5,14.1,1.4,19.2c0.6,3.2,1.1,6.3,1.7,9.4l0.5,2.5C4.9,60.5,6.3,68,7.5,75.2c1.5,8.5,1.9,15.2,1.3,21.3 c-0.2,2.6-0.7,5.4-1.1,8.1v0c-0.2,1.4-0.5,3-0.7,4.6c0,0.2,0,0.3-0.1,0.4c-0.2,0.7-0.3,1.7-0.3,3.3c0,7.2,5.6,13,12.4,13h10.2h0.3 h10.2c6.8,0,12.4-5.8,12.4-13c0-1.6-0.2-2.6-0.3-3.3c0-0.1,0-0.2-0.1-0.4c-0.2-1.6-0.5-3.2-0.7-4.6v0c-0.4-2.7-0.9-5.5-1.1-8.1 c-0.5-6.1-0.1-12.9,1.3-21.3c1.2-7.2,2.6-14.7,3.8-21.3l0.5-2.5c0.6-3.2,1.1-6.3,1.7-9.4C58,36.8,59,29.9,58.5,22.7z M55.6,41.7 c-0.5,3.1-1.1,6.2-1.7,9.4l-0.5,2.5c-1.2,6.6-2.5,14.1-3.8,21.3c-1.5,8.6-1.9,15.5-1.3,21.7c0.2,2.7,0.7,5.5,1.1,8.2v0 c0.2,1.5,0.5,3.1,0.7,4.6c0,0.2,0,0.4,0.1,0.6c0.1,0.6,0.3,1.5,0.3,3c0,6.4-4.9,11.5-10.9,11.5H29.5h-0.3H19 c-6,0-10.9-5.2-10.9-11.5c0-1.5,0.2-2.3,0.3-3c0-0.2,0.1-0.3,0.1-0.6c0.2-1.5,0.5-3.1,0.7-4.6v0c0.4-2.7,0.9-5.6,1.1-8.2 c0.6-6.2,0.1-13.1-1.3-21.7c-1.2-7.2-2.6-14.7-3.8-21.3l-0.5-2.5c-0.6-3.2-1.1-6.3-1.7-9.4c-0.9-5.2-1.9-12.1-1.4-19.3l1.4-11.7 c0.7-5.3,5-9.2,10-9.2h16.1h0.3h16.1c5,0,9.3,4,10,9.2L57,22.4C57.5,29.6,56.5,36.5,55.6,41.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 0.3565,
    y1: 19.5081,
    x2: 59.388,
    y2: 99.6196
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0130144,
    style: {
      stopColor: "#FEDD00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2166,
    style: {
      stopColor: "#FEC809"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6362,
    style: {
      stopColor: "#FF9022"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5C39"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M52.6,40.3c1.1-7.9,1.5-13.3,1.2-17.4c-0.4-4.2-0.7-8.7-1.5-12.8c-0.5-1.9-1.7-3.6-3.4-4.6c0,0-0.6-0.3-0.7-0.4 c-2.1-0.7-4.5-0.2-6.7-0.3c-3.8,0-7.5,0-11.3,0c-4.1,0-8.2,0-12.4,0c-2.5,0-6.2-0.2-8.1,0.9C6.2,7.4,6.1,12.8,5.6,16 c-1.4,8.1-1,16.5,0.6,24.5c3.4,22.9,11,46,5.5,69.1c-0.2,1.3-0.4,2.5-0.3,3.8l0-0.1c0.3,2.6,1.6,5,3.8,6.4l0-0.1 c0.3,0.2,0.7,0.4,1,0.5l0,0c0.2,0.1,0.6,0.2,0.8,0.3v0c4.1,0.7,8.4,0.1,12.6,0.3c4.1-0.2,8.4,0.4,12.5-0.3v0 c0.2-0.1,0.6-0.2,0.8-0.3l0,0c0.3-0.2,0.7-0.3,1-0.5l0,0.1c2.2-1.4,3.5-3.9,3.8-6.4l0,0.1c0.1-1.3-0.2-2.6-0.4-4 c-2.7-12.8-2.5-26,0.2-38.7C49,60.6,50.9,50.4,52.6,40.3z M29.3,115.7c-3.8-0.1-3.8-5.8,0-5.8C33.2,109.9,33.2,115.6,29.3,115.7z  M41,71.4c-0.3,2.7-0.8,5.5-1.2,8.2v0c-1,6.5-0.7,13.2-0.1,19.7c1.4,8.2-5,6.2-10.5,6.4c-5.4-0.2-11.8,1.7-10.5-6.4 c0.6-6.5,0.9-13.2-0.1-19.7v0c-1.8-12.6-4.4-25.2-6.2-37.8c-1-6-2.1-12.1-1.9-18.2c-0.3-3.5,1.2-5,4.7-3.9c4,0.6,8.1,1,12.1,1 c5.4-0.1,10.9,0,16.2-1.1c4.5-1.3,4.8,1.8,4.5,5.4C47.4,40.6,43.5,56,41,71.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.1091dbcc4588cfa43b9468dd7586bc02.svg";
export { ForwardRef as ReactComponent };